export interface StackItem {
  name: string
  detail: string
  price: number
}

export const stackItems: StackItem[] = [
  { name: 'Tomo 1 — Anatomía Aeronáutica', detail: '60 páginas', price: 29 },
  { name: 'Tomo 2 — Meteorología y Espacio Aéreo', detail: '70 páginas', price: 29 },
  { name: 'Tomo 3 — Negocio y Certificación', detail: '75 páginas', price: 29 },
  { name: 'Tomo 4 — Preparación para el Examen', detail: '80 páginas', price: 29 },
  { name: 'Bono 1 — Checklist “Ready to Fly”', detail: '30 páginas', price: 29 },
  { name: 'Bono 2 — Tabla de Requisitos Legales', detail: '30 páginas', price: 39 },
  { name: 'Bono 3 — Diccionario Técnico', detail: '30 páginas', price: 19 },
]

export const stackTotal = stackItems.reduce((sum, item) => sum + item.price, 0)

export const packFacts = [
  { label: 'Total', value: '350+ páginas de contenido técnico' },
  { label: 'Acceso', value: 'Inmediato, descarga en PDF' },
  { label: 'Dispositivos', value: 'Laptop, tablet y celular' },
  { label: 'Idioma', value: 'Español neutro, válido en toda LATAM' },
  { label: 'Garantía', value: '7 días sin preguntas a través de Hotmart' },
]
